export default {
	chufadimudidi: '出發地/目的地',
	xiugaisouxun: '修改搜尋',
	you: '由',
	xianshi: '顯示',
	jieguo: '結果',
	paixufangshi: '排序方式',
	zuipianyi: '最便宜',
	zuikuai: '最快',
	tuiguang: '推廣',
	tingzhan: '停站',
	tingzhanyi: '停站',
	zhifei: '直飛(不停站)',
	yigetingzhan: '1個停站',
	duoguoliangge: '多過2個停站',
	meiyouchangshijian: '沒有長時間停留',
	shaoyusixiaoshi: '少於4小時',
	jiagefanwei: '價格範圍',
	hanshui: '含稅',
	hangbanshikebiao: '航班時刻表',
	tingliushijian: '停留時間',
	tingliu: '停留',
	hangkonggongsi: '航空公司',
	lianmeng: '聯盟',
	jiebo: '接駁',
	zongjia: '總價',
	xianzaiyuding: '現在預訂',
	chakantanpai: '查看碳排放',
	shengyu: '剩餘',
	gezuowei: '個座位',
	zongfeixingshijian: '總飛行時間',
	feixingshijian: '飛行時間',
	hangbanxiangxixinxi: '班機詳細資訊',
	xianshigengduo: '顯示更多',
	quanxuan: '全選',
	qingchu: '清除',
	xuanzenindefukuanfangshi: '選擇您的付款方式',
	xinyongkajiejika: '信用卡/借記卡',
	qingshurunindexiangxixinxi: '請輸入您的信用卡/借記卡詳細資訊',
	xinyongkajiejikakahao: '信用卡/借記卡卡號',
	youxiaoriqi: '有效日期',
	kayanzhengma: '卡驗證碼',
	yanzhengmatishi: '卡驗證碼是位於信用卡背後，簽名方格內號碼的最後三個數字為 CVC2 (MasterCard)碼。',
	dianziyoujian: '電子郵寄地址（可選）',
	lijifukuan: '立即付款',
	quxiaobingfanhui: '取消並返回',
	wuxiaoka: '無效的卡',
	yichang: "狀態异常,請聯系銀行客服人員解决",
	jiagefashengbiandong: '价格发生变动，正在重新查询航班',
	ren: '人',
	chengkepingjunjiage: '每位乘客的平均價格',
};
